import React, { useState } from "react";
import {
  Button,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import HeadingSS from "App/BsesPoc/components/common/Heading/HeadingSS";

const AddFieldModal = ({
  isOpen,
  onClose,
  onSubmit,
  fieldType,
  parentKey,
  isField,
}: any) => {
  const [fieldName, setFieldName] = useState("");
  console.log("filed", isField);
  console.log("PKkkk", parentKey);
  const handleSubmit = () => {
    if (fieldName.trim()) {
        onSubmit(parentKey, fieldName, isField);
        onClose();
      }
  };

  const handleClose = () => {
    setFieldName("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered size={{base: "xs", md: "md"}}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HeadingSS headingSS={` Enter ${fieldType} Field Name`} /></ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Input
            placeholder={`${fieldType} Field Name`}
            value={fieldName}
            onChange={(e) => setFieldName(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="green"
            onClick={() => {
              handleSubmit();
              setFieldName("");
            }}
          >
            Add
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddFieldModal;
